import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from '../my-pipes/date-format.pipe';
import { EntryTypeHasHorsePipe } from '../my-pipes/entry-type-has-horse.pipe';
import { EntryTypeWoHorsePipe } from '../my-pipes/entry-type-wo-horse.pipe';
import { EntryTypeIsBarnAccountPipe } from '../my-pipes/entry-type-is-barn-account.pipe';
import { SafePipe } from '../my-pipes/safe.pipe';
import { RequestOnlyFilterPipe } from '../my-pipes/request-only-filter.pipe';
import { ActiveAccountItemPipe } from '../my-pipes/active-account-item.pipe'
import {DateFormatWithTimePipe} from '../my-pipes/date-format-with-time.pipe';

@NgModule({
  declarations: [  DateFormatPipe, EntryTypeHasHorsePipe, EntryTypeWoHorsePipe, EntryTypeIsBarnAccountPipe, SafePipe, RequestOnlyFilterPipe, ActiveAccountItemPipe, DateFormatWithTimePipe ],
  imports: [
    CommonModule
  ],
  exports: [
	  DateFormatPipe,
	  EntryTypeHasHorsePipe,
	  EntryTypeWoHorsePipe,
	  EntryTypeIsBarnAccountPipe,
    SafePipe,
    RequestOnlyFilterPipe,
    ActiveAccountItemPipe,
    DateFormatWithTimePipe
  ]
})
export class AppCommonPipesModule { }
